/** RFC 4180 CSV with formula-injection protection for spreadsheet consumers. */
export function csvEscape(value: unknown): string {
  if (value === null || value === undefined) return '';
  let s = String(value);
  if (/^[=+\-@\t\r]/.test(s) && !/^-?\d+(\.\d+)?$/.test(s)) s = `'${s}`;
  if (/[",\r\n]/.test(s)) s = `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function toCsv<T extends Record<string, unknown>>(rows: T[], columns: { key: keyof T; header: string }[]): string {
  const lines = [columns.map(c => csvEscape(c.header)).join(',')];
  for (const r of rows) lines.push(columns.map(c => csvEscape(r[c.key])).join(','));
  return lines.join('\r\n') + '\r\n';
}
